import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Standard shadcn `cn` helper — combines `clsx` semantics with
 * `tailwind-merge` so later utility classes win over earlier ones
 * even when they target the same Tailwind property.
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
